(function () {
	"use strict";

	angular.module("swurveys.maker")
		.factory('swurveyTemplateService', Handler)

	function Handler(utilsService) {

		var swurveyTemplateService = {};

		swurveyTemplateService.getStandard = function (cb) {
			var m = {
				data: {
					version: "1.1",
					paymentTier: "Feedback",
					styles: [
						".viewer { background-image: url(); background-color: #27ccc0;}",
						".logo-image { background-image: url(); }",
						".card-border { border-radius: 5px; }",
						".card-top-bg { background-image: url(); background-color: #f6f6f6;}",
						".card-text {color: #212121;}",
						".card-text b { color: #212121; }",
						".hint-text {color: #212121;}",
						".ui-slider-horizontal .ui-slider-handle { background-image: url(); background-color: #D4D3D3; border: 2px solid; border-color: #D4D3D3; border-radius: 50%;}",
						".likertControl {background-color: #000000; border-color: #FFFFFF; } ",
						".slider-control {background-color: #000000; border-color: #FFFFFF; } ",
						".circle { background-color: #212121; } ",
						".viewer .fa { color: #000000; }",
						".counter-wrapper b { color: #000000; }",
						"#loading { background-image: url();}",
						"#WOTPercentage { color: #5bc4b6; }",
						".dataLink { color: #ffffff; }",
						".WOTText { color: #848484; }",
						".WOTMainText { color: #ffffff; }",
						".socialcircle  { background-color: #5bc4b6; }",
						".custom-link { color: #000000; }",
						//Make sure custom line-height doesn't break tutorial
						".extra-mile-font.text-center { line-height: 1em; }"
					],
					cards: [{
						type: "content",
						text: "<b>Cover</b> Card",
						id : utilsService.generateUUID(true) 
					}],
					options: {
						skipTutorial: true,
						publicData: true,
						share: {
							enabled: true,
							text: "",
							methods: [
								"facebook",
								"twitter",
								"google",
								"linkedin",
								"sms"
							]
						},
						customEmail: {
							enabled: false,
							methods : []
						},
						action: {
							enabled: false,
							methods: []
						},
		        shareImg: {
			      	default: "https://app.swurveys.com/assets/fbpreview.jpeg"
		        },
						referralCard : {
							enabled : true
						}
					},
					fileLibrary: []
				}
			};

			cb(m);
		}

		return swurveyTemplateService;
	}

}());
